import * as yup from 'yup';

export const fileSchema = yup.object().shape({
  files: yup.mixed().nullable(),
});
